export type BenachrichtigungsKanal = 'dashboard' | 'mail' | 'beides';

export type BenachrichtigungsArt = 'uebergabe' | 'testlauf' | 'review' | 'abweichung' | 'pipeline' | 'ki';

export type Benachrichtigungen = Record<BenachrichtigungsArt, BenachrichtigungsKanal>;

export const BENACHRICHTIGUNGS_ARTEN: readonly BenachrichtigungsArt[] = [
  'uebergabe',
  'testlauf',
  'review',
  'abweichung',
  'pipeline',
  'ki',
];

export const BENACHRICHTIGUNGS_KANAELE: readonly BenachrichtigungsKanal[] = ['dashboard', 'mail', 'beides'];
